import { Component, forwardRef } from "@angular/core";
import { StartAction } from "../../../../Model/Dto/StartAction";
import { TranslateService } from "@ngx-translate/core";
import { UserActionBaseComponent } from "../userAction-base.component";
import { ModelService } from "app/Services/model.service";
import { lastValueFrom, retry } from "rxjs";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { JobService } from "app/Services/job.service";
import { LoginService } from "app/Services/login.service";

@Component({
    selector: 'useraction-createUniqueGroupIds',
    templateUrl: './useraction-createUniqueGroupIds.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UseractioncreateUniqueGroupIdsComponent) }
    ],
    standalone: false
})
export class UseractioncreateUniqueGroupIdsComponent extends UserActionBaseComponent {
  useObjectIds: boolean = false;
  
  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      useObjectIds: this.useObjectIds
    });
  }
  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.useObjectIds = parsed.useObjectIds;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
